import React from 'react';
import PropTypes from 'prop-types';
import HoverTooltip from '@Components/HoverTooltip';
import { Button } from '@els/els-react--button';
import { TooltipConstants } from '@Components/Tooltip';
import ReactDOMServer from 'react-dom/server';
import { copySmiles, getCustomerIconAriaLabel, getCustomerSpecificMapping, trackCustomerIconClick } from './structure-utils';
import StructureToolbarCustomerIconTooltip from './StructureToolbarCustomerIconTooltip';

import './StructureToolbarCustomerIcon.scss';

export default function StructureToolbarCustomerIcon({ structure, customerInfo = {} }) {
  const onClick = () => {
    const { label } = getCustomerSpecificMapping(customerInfo.name);
    trackCustomerIconClick(label);
    return copySmiles(structure);
  };
  const { icon, label } = getCustomerSpecificMapping(customerInfo.name);
  const tooltip = ReactDOMServer.renderToString(<StructureToolbarCustomerIconTooltip customerLabel={label} />);
  const ariaLabel = getCustomerIconAriaLabel(label) || '';
  return (
    <HoverTooltip id={TooltipConstants.ids.GlobalHover} tooltip={tooltip} theme="simple" tooltipPlace="top">
      <Button
        data-e2e="structure-toolbar-customer-icon-button"
        type="borderless"
        size="small"
        onClick={onClick}
        className={`structure-customer-icon e2e-structure-customer-icon ${icon}`}
        aria-label={ariaLabel}>
        <svg className="els-btn-icon rx-border-none">
          <use xlinkHref={`#icon-${icon}`} />
        </svg>
      </Button>
    </HoverTooltip>
  );
}

StructureToolbarCustomerIcon.propTypes = {
  structure: PropTypes.string,
  customerInfo: PropTypes.object,
};
